import PropTypes from 'prop-types';
import Icon from '../../icon';

export default function SearchButton({ openSearch }) {
  let reference;
  return (
    <button
      onClick={openSearch}
      title="Search in article"
      type="button"
      tabIndex="0"
      ref={(domEl) => { reference = domEl; }}
      onMouseLeave={() => reference.blur()}
      className="toolbar-icon u-margin-m-right"
      id="search-button"
    >
      <Icon.Search />
    </button>
  );
}

SearchButton.propTypes = {
  openSearch: PropTypes.func.isRequired,
};
